import React from 'react';
import plasticDetail from '../img/Detail/plastic-detail.jpg';
import './Detail.css';
const PlasticDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={plasticDetail} alt="Event Space Design Plastic Free Festival" />
    </div>
  );
};

export default PlasticDetail;
